import styles from './CircleArrowButton.module.scss';

import cx from 'classnames';
import { TextWithArrow } from 'components/TextWithArrow/TextWithArrow';
import React, { ButtonHTMLAttributes, ComponentProps, FC } from 'react';

type CircleArrowButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  theme?: ComponentProps<typeof TextWithArrow>['theme'];
  variant?: 'left' | 'right';
};

export const CircleArrowButton: FC<CircleArrowButtonProps> = ({
  className,
  theme = 'light',
  variant = 'left',
  type = 'button',
  ...props
}) => {
  return (
    <button className={cx(styles.root, styles[variant], className)} type={type} {...props}>
      <TextWithArrow className={styles.arrow} theme={theme} variant="caret" />
    </button>
  );
};
